export const typesAuthForm: { LOGIN: string; REGISTRATION: string; FORGOT: string } = {
  LOGIN: 'LOGIN',
  REGISTRATION: 'REGISTRATION',
  FORGOT: 'FORGOT',
};

export default typesAuthForm;
